import { defineMessages } from 'react-intl';
import { copyToClipboard } from '../../../../../services/copy-to-clipboard';

const messages = defineMessages({
  copyTrackingNumber: {
    description: 'shipmentDetailsOtherActions.copyTrackingNumber',
    defaultMessage: 'Copy Tracking Number',
    id: 'H/KFbi',
  },
});

export const CopyTrackingNumber = {
  translation: messages.copyTrackingNumber,

  handler: ({ trackingNumber }) => {
    copyToClipboard(trackingNumber);
  },

  shouldBeShown: ({ trackingNumber }) => {
    return trackingNumber;
  },
};
